/** @format */
import {guard, OBJECT, ENUM, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {FSK_DISCLAIMER_DONE, localStore} from './browser-storage.js';
import {post, put} from '../core/service/backend.js';
import {popup} from '@acng/frontend-discovery';
import {service} from 'nova';
import {t} from '../locale/config/translate.js';

@service
class AgeVerificationApi {
  /**
   * @param {Element} [initiator]
   *
   * @returns {Promise<void>}
   */
  async putAdult(initiator) {
    localStore[FSK_DISCLAIMER_DONE] = true;
    await put('user/fsk', {fsk: 18}, initiator);
  }

  /**
   * @param {Element} [initiator]
   *
   * @returns {Promise<void>}
   */
  async putUnderage(initiator) {
    localStore[FSK_DISCLAIMER_DONE] = true;
    await put('user/fsk', {fsk: 12}, initiator);
  }

  /**
   * @param {Element} [initiator]
   *
   * @returns {Promise<void>}
   */
  async start(initiator) {
    localStore[FSK_DISCLAIMER_DONE] = true;

    const startResult = await post('user/age-verification/start', {}, initiator);
    ASSERT: guard(startResult, AVS_START_RESPONSE);

    switch (startResult.status) {
      case 'successful':
        popup().info(await t('userPool.avs.alreadyVerified'));
        break;

      case 'error':
        popup().error(await t('userPool.avs.errors.startServiceRequest'));
        break;

      case 'initiated':
        window.open(`${startResult.redirect_url}`);
        break;

      default:
        ASSERT: throw new Error('Unexpected age verification request result');
    }
  }

  cancel() {
    localStore[FSK_DISCLAIMER_DONE] = true;
  }
}

const AVS_START_RESPONSE = /* @__PURE__ */ (() =>
  OBJECT({
    status: ENUM(/** @type {const} */ (['successful', 'error', 'initiated'])),
    redirect_url: OPTIONAL(STRING),
  }))();

export {AgeVerificationApi};
